type TT = <T>(value: T) => T

export const removeEmptyValues: TT = value =>
    JSON.parse(
        JSON.stringify(value, (_, val) =>
            val === null || val === undefined || val.length === 0
                ? undefined
                : val
        )
    )
